'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentMoneroAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M42 9.00049C53.0438 9.00049 61.9997 17.956 61.9997 29C61.9997 31.2075 61.642 33.3308 60.9813 35.3172H54.9999V18.49L42 31.49L29.0002 18.49V35.3172H23.0186C22.3575 33.3308 21.9997 31.2075 21.9997 29C21.9997 17.956 30.9558 9.00049 42 9.00049Z",
          fill: "#FF6600"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M44.9895 34.4784L50.6629 28.8048V39.3931H52.8317H55.0004H59.0901C55.5793 45.1529 49.2384 48.9995 42.0006 48.9995C34.7628 48.9995 28.4213 45.1529 24.9109 39.3931H29.001H32.8801H33.3379V28.8048L39.0115 34.4784L42.0006 37.4672L44.9892 34.4784H44.9895Z",
          fill: "#4C4C4C"
        }
      )
    ]
  }
);
const VpPaymentMoneroAsset = forwardRef(PaymentMoneroAsset);

export { VpPaymentMoneroAsset as default };
